module.exports = __webpack_public_path__ + "static/media/logo-light.64afcf2b.svg";